import { render, staticRenderFns } from "./FormArchiveBtn.vue?vue&type=template&id=fe72486c"
import script from "./FormArchiveBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormArchiveBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports